import React from "react";
import { Link, Text, View, StyleSheet } from "@react-pdf/renderer";
import { header } from "../../constants/profile";
import { globalStyles } from "../../views/Resume";

const styles = StyleSheet.create({
  name: {
    fontSize: 7,
    fontFamily: "Lato Bold",
    marginBottom: "2px",
  },
  contact: {
    display: "flex",
    flexDirection: "row",
    gap: "5px",
  },
  link: {
    fontFamily: "Lato",
    fontSize: 6,
    color: "black",
    textDecoration: "none",
  },
  icon: {
    width: "8px",
    height: "8px",
    objectFit: "contain",
    marginLeft: "2px",
    marginRight: "2px",
  },
  linkView: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  separator: {
    fontSize: 6,
  },
});

const Header = () => (
  <>
    <View style={globalStyles.container}>
      <View>
        <Text style={styles.name}>{header.name}</Text>
        <Text style={styles.name}>{header.title}</Text>
      </View>

      <View style={styles.contact}>
        <View style={styles.linkView}>
          <Link href={`mailto:${header.links.email}`} style={styles.link}>
            {header.links.email}
          </Link>
        </View>
        <Text style={styles.separator}>|</Text>
        <View style={styles.linkView}>
          <Link href={`tel:${header.links.tel}`} style={styles.link}>
            {header.links.tel}
          </Link>
        </View>
        <Text style={styles.separator}>|</Text>
        <View style={styles.linkView}>
          <Link
            href={`https://linkedin.com/in/${header.links.linkedIn}`}
            target="_blank"
            style={styles.link}
          >
            {`https://linkedin.com/in/${header.links.linkedIn}`}
          </Link>
        </View>
        <Text style={styles.separator}>|</Text>
        <View style={styles.linkView}>
          <Link href={header.links.portfolio} style={styles.link}>
            {header.links.portfolio}
          </Link>
        </View>
      </View>
    </View>
  </>
);

export default Header;
